import View from "../framework/view";
import Server from "../server";
import template from "../../pugc/edit-menu";
import jQuery from "jquery";
import Alerts from "../misc/alerts";
import {formToJson} from "../misc/utils";
import {EditMenuNotification, EditWebsiteNotification} from "./wrb";
import {Website} from "../bo/website";
import {Menu} from "../bo/menu";

const classname = "edit-menu-view";

function nameToPath(name: string | undefined) {
    name = name || "";
    return encodeURIComponent(name.toLowerCase().trim().replace(/ /g, "-"));
}

export class EditMenuView extends View {

    private readonly server = Server.instance();

    private name: string;

    private website?: Website;

    private menu?: Menu;

    private moving: string | undefined;

    constructor(name: string) {
        super(classname);
        this.name = name;
        this.load();
    }

    async load() {
        const w = await this.server.website();

        // Copy because we mutate website later
        this.website = JSON.parse(JSON.stringify(w)) as Website;
        const menus = this.website.menus || [];
        this.menu = menus.filter(p => p.name == this.name)[0];
        this.update();
    }

    protected render0(): JQuery<HTMLElement> {

        if (! this.menu) {
            return jQuery("<div>");
        }

        const data = {
            menu: this.menu,
            menus: this.website?.menus || [],
            pages: this.website?.pages || [],
            moving: this.moving
        };

        return this.pug(template, data);
    }

    async delete() {
        const YES_DELETE = "Yes, really delete";
        const NO = "No, don't delete";

        const confirm = await Alerts.confirmation({
            options: [ YES_DELETE, NO ],
            message: "Really delete page?"
        });

        if (confirm == YES_DELETE) {
            const w = await this.server.website();
            const ps = w.menus as Menu[];
            const p2: Menu[] = [];
            for (const p of ps) {
                if (p.name != this.name) {
                    p2.push(p);
                }
            }
            w.menus = p2;
            await this.server.saveWebsite(w);
            this.notify(new EditWebsiteNotification());
        }
    }

    async save() {
        if (! this.menu) {
            return;
        }
        const form = this.elt().find("form");
        const data : any = {};
        formToJson(form, data);

        this.menu.name = data.name;
        this.menu.enabled = data.enabled;

        const website = await this.server.website();

        if (! website.menus) {
            website.menus = [];
        }
        const idx = website.menus.findIndex(m => m.name == this.name);
        if (idx == -1) {
            website.menus.push(this.menu);
        } else {
            website.menus[idx] = this.menu;
        }
        await this.server.saveWebsite(website);
        this.notify(new EditMenuNotification(this.menu.name as string));
    }

    addPage(path: string) {
        if (! this.menu || ! this.menu.items || ! this.website) {
            return;
        }
        const page = (this.website.pages || []).filter(p => p.path == path)[0];
        this.menu.items.push({
            name: page.name,
            url: page.path,
            item_type: "page"
        });
        this.update();
    }

    addMenu(name: string) {
        if (! this.menu || ! this.menu.items || ! this.website) {
            return;
        }
        const menu = (this.website.menus || []).filter(m => m.name == name)[0];
        this.menu.items.push({
            name: menu.name,
            item_type: "menu"
        });
        this.update();
    }

    deleteItem(idx: number) {
        if (this.menu && this.menu.items) {
            this.menu.items.splice(idx, 1);
            this.update();
        }
    }

    moveItem(name: string) {
        this.moving = name;
        this.update();
    }

    moveHere(destIdx: number) {
        if (this.moving && this.menu) {
            const items = this.menu.items || [];

            const srcIdx = items.findIndex(x => x.name == this.moving);

            if (srcIdx != destIdx) {
                const moved = items.splice(srcIdx, 1);
                const adj = destIdx > srcIdx ? 0 : 1;
                items.splice(destIdx + adj, 0, moved[0]);
            }

            this.moving = undefined;
            this.update();
        }
    }
}

View.on(
    "." + classname,
    "click",
    "a.delete-item",
    function(that: EditMenuView, event, elt) {
        event.preventDefault();
        const idx = jQuery(elt).closest(".item").data("idx") as number;
        that.deleteItem(+idx);
    });

View.on(
    "." + classname,
    "click",
    "a.move-item",
    function(that: EditMenuView, event, elt) {
        event.preventDefault();
        const name = jQuery(elt).closest(".item").data("name") as string;
        that.moveItem(name);
    });

View.on(
    "." + classname,
    "click",
    "a.move-here",
    function(that: EditMenuView, event, elt) {
        event.preventDefault();
        const idx = jQuery(elt).data("idx") as any as number;
        that.moveHere(idx);
    });

View.on(
    "." + classname,
    "change",
    "select.add-page",
    function(that: EditMenuView, event, elt) {
        event.preventDefault();
        const path = jQuery(elt).val() as string;
        that.addPage(path);
    });

View.on(
    "." + classname,
    "change",
    "select.add-menu",
    function(that: EditMenuView, event, elt) {
        event.preventDefault();
        const name = jQuery(elt).val() as string;
        that.addMenu(name);
    });

View.on(
    "." + classname,
    "click",
    "button.save",
    function(that: EditMenuView, event, elt) {
        event.preventDefault();
        that.save();
    });

View.on(
    "." + classname,
    "click",
    "button.delete",
    function(that: EditMenuView, event, elt) {
        event.preventDefault();
        that.delete();
    });
